export default __webpack_public_path__ + "static/media/Linux.98e650ec.png";